import { hasValue } from 'utils/hasValue';

export function formatAmount({
  amount,
  currency
}: {
  amount: string | number | undefined;
  currency: string | undefined | null;
}) {
  try {
    if (!hasValue(amount)) return 'N/A';
    if (Number.isNaN(Number(amount))) return 'N/A';

    if (!currency) return amount.toString();

    return Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    }).format(Number(amount));
  } catch {
    return 'N/A';
  }
}
